<template>
  <div class="col-xl-12" id="BoxPhoneResult" style="border-color: rgba(94, 0, 182, 1);">
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form class="form" autocomplete="off" @submit.prevent="handleSubmit(handleOk)">
        <div class="mb-3 m-2 ">
          <div v-loading="loadingShowInfo" class="row">
            <div class="col-md-6 mt-2 ">
              <label class="fs-1 font">Kết quả<span class="text-danger"> *</span></label><br>
              <ValidationProvider vid="status" name="Trạng thái" rules="required" v-slot="{ errors, classes }">
                <el-select size="large" v-model="query.type" placeholder="Chọn trạng thái..." clearable class="w-100"
                           filterable @change="handleChangeResult">
                  <el-option
                      v-for="item in handleListResult"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      :disabled="item.disabled"
                  >
                  </el-option>
                </el-select>
                <div class="fv-plugins-message-container">
                  <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6 mt-2" v-if="query.type === DONG_Y_HOC">
              <label class="fs-1 font">Lớp học<span class="text-danger"> *</span></label><br>
              <ValidationProvider vid="status" name="Lớp học" rules="required" v-slot="{ errors, classes }">
                <el-select
                  size="large" v-model="query.class_room"
                  placeholder="Chọn lớp học" clearable
                  filterable class="w-100"
                  :disabled="taskInfo.classroom_id"
                  popper-class="classroom-noti-popper"
                  no-match-text="Lớp học không tồn tại. Vui lòng liên hệ với bộ phận mở lớp để kiểm tra thông tin."
                >
                  <el-option
                    v-for="item in listClassRoom"
                    :key="item.id"
                    :value="item.id"
                    :label=" item.name"
                    :disabled="checkDisableRoom(item)"
                  >
                    <template>
                      <div class="class-item">
                        <span style="font-size: 15px">{{ item.name }}</span>
                        <span class="badge badge-secondary ml-3">
                          {{ item.branch_name }} | Sĩ số: {{ item.current_student }}/{{ item.number_student }}
                        </span>
                      </div>
                    </template>
                  </el-option>
                </el-select>
                <div class="fv-plugins-message-container">
                  <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6 mt-2" v-if="query.type === CHO_LOP_SAU">
              <label class="fs-1 font">Lịch học mong muốn</label><br>
              <el-select
                  v-model="query.expectCalendar"
                  placeholder="Lịch học mong muốn"
                  size="large"
                  style="width: 240px"
                  multiple
                  class="w-100"
              >
                <el-option
                    v-for="item in listCalendar"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                />
              </el-select>
            </div>
            <div class="col-md-6 mt-2" v-if="query.type === CHO_LOP_SAU">
              <label class="fs-1 font">Thời gian có thể đi học<span class="text-danger"> *</span></label><br>
              <ValidationProvider
                vid="time_go_school"
                name="Thời gian đi học"
                rules="required"
                v-slot="{ errors, classes }"
              >
                <date-picker
                  v-model="query.dateGoSchool"
                  type="datetime"
                  placeholder="Thời gian có thể đi học"
                  format="HH:mm DD-MM-YYYY"
                  valueType="YYYY-MM-DD HH:mm"
                  class="w-100"
                >

                </date-picker>
                <div class="fv-plugins-message-container">
                  <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6 mt-2" v-if="query.type === GIA_HAN_BO_SUNG_NANG_LUC">
              <label class="fs-1 font">Deadline gia hạn bổ sung năng lực<span class="text-danger"> *</span></label><br>
              <ValidationProvider
                vid="Deadline gia hạn bổ sung năng lực"
                name="Deadline gia hạn bổ sung năng lực"
                rules="required"
                v-slot="{ errors, classes }"
              >
                <date-picker
                  v-model="query.extensionDeadline"
                  type="datetime"
                  placeholder="Deadline gia hạn bổ sung năng lực"
                  format="HH:mm DD-MM-YYYY"
                  valueType="YYYY-MM-DD HH:mm"
                  class="w-100"
                >
                </date-picker>
                <div class="fv-plugins-message-container">
                  <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6 mt-2"
                 v-if="checkShowCallTime">
              <label class="fs-1 font">Thời gian gọi lại<span class="text-danger" v-if="!checkShowCallTimeNotRequired"> *</span></label><br>
              <ValidationProvider
                  vid="Thời gian gọi lại"
                  name="Thời gian gọi lại"
                  :rules="!checkShowCallTimeNotRequired ? 'required' : ''"
                  v-slot="{ errors, classes }"
              >
                <date-picker
                  v-model="query.timeCallAgain"
                  type="datetime"
                  placeholder="Thời gian gọi lại"
                  format="HH:mm DD-MM-YYYY"
                  valueType="YYYY-MM-DD HH:mm"
                  class="w-100"
                >
                </date-picker>
                <div class="fv-plugins-message-container">
                  <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-12 mt-3" v-if="query.type === CHO_LOP_SAU">
              <label class="fs-1 font">Chi nhánh học mong muốn<span class="text-danger"> *</span></label><br>
              <ValidationProvider vid="Chi nhánh học mong muốn" name="Chi nhánh học mong muốn" rules="required" v-slot="{ errors, classes }">
                <el-select
                  v-model="query.expectBranches"
                  placeholder="Chi nhánh học mong muốn"
                  size="large"
                  multiple
                  class="w-100"
                  filterable
                >
                  <el-option
                    v-for="item in listBranches"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
                <div class="fv-plugins-message-container">
                  <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6 mt-2" v-if="isUseNextCourse">
              <label class="fs-1 font">Khóa học tiếp theo</label><br>
              <el-select
                v-model="query.nextCourse"
                placeholder="Khóa học tiếp theo"
                size="large"
                style="width: 240px"
                class="w-100"
              >
                <el-option
                  v-for="item in listNextCourse"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <div class="col-md-12 mt-3">
              <label class="fs-1 font">Ghi chú cuộc gọi</label><br>
              <ValidationProvider
                vid="Ghi chú"
                name="Ghi chú"
                rules="max_call_note:300"
                v-slot="{ errors, classes }"
              >
                <ckeditor style="position: relative;" :editor="editor" v-model="query.call_note"></ckeditor>
                <div class="fv-plugins-message-container">
                  <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="pr-2">
          <div class="d-flex justify-content-end mt-4 mb-4 ">
            <el-button
              @click="dialogConfirm = true"
              class="mr-1" size="mini"
              style="color: #000; background-color: rgba(230, 230, 230, 1);"
            >
              Quay lại
            </el-button>
            <el-button
              @click="handleSubmit(saveResult)"
              size="mini"
              style="color: #fff; background-color: rgba(94, 0, 182, 1);"
              :disabled="loading">
              Lưu kết quả
            </el-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <el-dialog id="dialogConfirmResultPhone" width="30%" title="Rời trang?" :visible.sync="dialogConfirm" top="25vh">
      <div class=" border-dark border-1 pt-2 pb-2" style="word-break: initial!important; color:rgba(0, 0, 0, 1); line-height: 30px;">
        <span>Kết quả cuộc gọi của bạn chưa được lưu.</span><br>
        <span>Bạn có chắc chắn muốn rời trang?</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" class="rounded" style=" width: 100px; background-color: rgba(230, 230, 230, 1); color:#000" @click="switchBox">Rời đi</el-button>
        <el-button size="mini" class="rounded" style=" width: 100px; background-color: rgba(94, 0, 182, 1); color:#fff" @click="dialogConfirm = false">Ở lại</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadVideo from "../../../pages/tickets/components/UploadVideo";
import {
  FAIL_COURSE_RESULT_ARRAY, FAIL_COURSE_RESULT_DEFAULT, KHAI_GIANG,
  NEAR_RESULT_DEFINE_ARRAY, OPENING_RESULT_DEFINE_ARRAY,
  PASS_COURSE_RESULT_DEFINE_ARRAY, XEP_LOP, XU_LY_FALL_KHOA, XU_LY_PASS_KHOA
} from "@/core/option/taskArrangePersonal";
import CustomEditor from "@/core/plugins/ckeditor5/custom-editor";
import {
  GET_LIST_CALENDAR_OF_CENTER, GET_LIST_NEXT_COURSE,
  LIST_CLASSROOM, SAVE_RESULT_TASK,
  GET_LIST_BRANCH_BY_TICKET
} from "@/core/services/store/task-management/task-management.module";
import {
  CHO_LOP_SAU,
  NGUNG_CUNG_CAP_DICH_VU,
  DONG_Y_HOC,
  HEN_GOI_LAI,
  HOC_KHOA_TIEP_THEO,
  DA_XAC_NHAN_HOC_LEN_KHONG_CAM_KET,
  KHONG_NGHE_MAY_LAN_1,
  KHONG_NGHE_MAY_LAN_2,
  KHONG_NGHE_MAY_LAN_3,
  KHONG_NGHE_MAY_LAN_4,
  GIA_SU,
  DUYET_PASS_NANG_LUC,
  HOC_BO_TRO_CAP_TOC,
  GIA_HAN_BO_SUNG_NANG_LUC,
  ON_TAP_CUNG_GIANG_VIEN,
  HO_TRO_HOC_VIEN_CAI_THIEN_NANG_LUC
} from "@/core/option/TaskManagementOption";
import moment from "moment-timezone";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {HANDLE_CHEAT, XU_LY_GIAN_LAN} from "@/core/option/taskArrangePersonal";
import {Cambridge_Mentor_ID, IELTS_MENTOR_ID} from "@/core/option/typeCenterBill";
import { extend } from 'vee-validate';

function getCallNoteTextLength(value = '') {
  if (!value) {
    return 0;
  }

  const withoutImages = String(value)
    .replace(/<figure[\s\S]*?<\/figure>/gi, '')
    .replace(/<img[\s\S]*?>/gi, '');

  const text = withoutImages
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return text.length;
}

extend('max_call_note', {
  validate(value, { length }) {
    return getCallNoteTextLength(value) <= Number(length);
  },
  params: ['length'],
  message: 'Ghi chú không thể có nhiều hơn {length} kí tự',
});

export default {
  name: "ResultPhoneHistory",
  components: {UploadVideo, DatePicker},
  data() {
    return {
      loading: false,
      dialogConfirm: false,
      loadingShowInfo: false,
      ListNearResult: [],
      editor: CustomEditor,
      query: {
        type: '',
        class_room: '',
        call_note: '',
        dateGoSchool: '',
        extensionDeadline: '',
        timeCallAgain: '',
        expectCalendar: null,
        nextCourse: null,
        expectBranches: this.taskInfo.chi_nhanh_hoc_id ? [this.taskInfo.chi_nhanh_hoc_id] : []
      },
      listClassRoom: [],
      value: '',
      listCalendar: [],
      listBranches: [],
      DONG_Y_HOC,
      KHONG_NGHE_MAY_LAN_4,
      KHONG_NGHE_MAY_LAN_3,
      KHONG_NGHE_MAY_LAN_2,
      KHONG_NGHE_MAY_LAN_1,
      CHO_LOP_SAU,
      NGUNG_CUNG_CAP_DICH_VU,
      GIA_SU,
      NEAR_RESULT_DEFINE_ARRAY,
      OPENING_RESULT_DEFINE_ARRAY,
      PASS_COURSE_RESULT_DEFINE_ARRAY,
      FAIL_COURSE_RESULT_ARRAY,
      XEP_LOP,
      HOC_KHOA_TIEP_THEO,
      DA_XAC_NHAN_HOC_LEN_KHONG_CAM_KET,
      listNextCourse: [],
      XU_LY_FALL_KHOA,
      HEN_GOI_LAI,
      HANDLE_CHEAT,
      FAIL_COURSE_RESULT_DEFAULT,
      DUYET_PASS_NANG_LUC,
      GIA_HAN_BO_SUNG_NANG_LUC,
    }
  },
  mounted() {
    // this.query.dateGoSchool = moment(this.taskInfo?.created_at, 'HH:mm:ss DD-MM-YYYY').format('YYYY-MM-DD HH:mm')
    this.query.dateGoSchool = ''
    this.getListCLass();
    this.getStudyCalendarOfCenter()
    this.getNextCourse();
    this.getListBranches();
  },
  computed: {
    checkShowCallTime() {
      return (([CHO_LOP_SAU,KHONG_NGHE_MAY_LAN_3,KHONG_NGHE_MAY_LAN_2,KHONG_NGHE_MAY_LAN_1, HEN_GOI_LAI, KHONG_NGHE_MAY_LAN_4, NGUNG_CUNG_CAP_DICH_VU].includes(this.query.type) && this.taskInfo?.type_num === XEP_LOP))
          || (([KHONG_NGHE_MAY_LAN_2,KHONG_NGHE_MAY_LAN_1, HEN_GOI_LAI, GIA_SU].includes(this.query.type) && (this.taskInfo?.type_num === XU_LY_FALL_KHOA || this.taskInfo?.type_num === XU_LY_GIAN_LAN))
              || (this.taskInfo?.type_num === KHAI_GIANG && [HEN_GOI_LAI, KHONG_NGHE_MAY_LAN_1].includes(this.query.type)))
          || (this.taskInfo?.type_num === XU_LY_FALL_KHOA && [HOC_BO_TRO_CAP_TOC, GIA_HAN_BO_SUNG_NANG_LUC, ON_TAP_CUNG_GIANG_VIEN, HO_TRO_HOC_VIEN_CAI_THIEN_NANG_LUC].includes(this.query.type))
    },
    checkShowCallTimeNotRequired() {
      return (this.taskInfo?.type_num === XEP_LOP && [NGUNG_CUNG_CAP_DICH_VU].includes(this.query.type))
    },
    isUseNextCourse() {
      return [DA_XAC_NHAN_HOC_LEN_KHONG_CAM_KET, HOC_KHOA_TIEP_THEO, DUYET_PASS_NANG_LUC].includes(this.query.type)
    },
    handleListResult() {
      switch (this.taskInfo?.type_num) {
        case XEP_LOP:
          return  this.NEAR_RESULT_DEFINE_ARRAY
        case XU_LY_FALL_KHOA:
          if([IELTS_MENTOR_ID, Cambridge_Mentor_ID].includes(this.taskInfo.center_id)) {
            return this.FAIL_COURSE_RESULT_ARRAY.map(item => {
              return {
                ...item,
                disabled: (item?.id === DUYET_PASS_NANG_LUC && this.taskInfo && (this.taskInfo?.percent_pass_group_level < 64 || this.taskInfo?.final_mark_test?.final_avg_score < this.taskInfo?.final_mark_test?.score_pass)) || (item?.id === DA_XAC_NHAN_HOC_LEN_KHONG_CAM_KET && this.listNextCourse?.length === 0)
              }
            })
          } else {
            return this.FAIL_COURSE_RESULT_DEFAULT.map(item => {
              return {
                ...item,
                disabled: item?.id === DUYET_PASS_NANG_LUC && this.taskInfo && (this.taskInfo?.percent_pass_group_level < 64 || this.taskInfo?.final_mark_test?.final_avg_score < this.taskInfo?.final_mark_test?.score_pass)
              }
            })
          }
        case XU_LY_PASS_KHOA:
          return this.PASS_COURSE_RESULT_DEFINE_ARRAY
        case KHAI_GIANG:
          return this.OPENING_RESULT_DEFINE_ARRAY
        case XU_LY_GIAN_LAN:
          return this.HANDLE_CHEAT
        default:
          return []
      }
    },
  },
  props: {
    taskInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    'query.extensionDeadline'(value, oldValue) {
      if (this.query.type === GIA_HAN_BO_SUNG_NANG_LUC
          && (!this.query.timeCallAgain || this.query.timeCallAgain === oldValue)) {
        this.query.timeCallAgain = value
      }
    }
  },
  methods: {
    switchBox() {
      this.$emit('showBoxResultPhone', false);
    },

    getListCLass() {
      this.$store.dispatch(LIST_CLASSROOM, this.$route.params.id).then((res) => {
        if (!res.error) {
          this.listClassRoom = res.data
          if (this.taskInfo.classroom_id !== 0) {
            this.listClassRoom = [...this.listClassRoom,{id: this.taskInfo.classroom_id,name:this.taskInfo.classroom_name}]
            this.query.class_room = this.taskInfo.classroom_id
          }
        }
      }).catch((e) => {
        console.log(e, 'error')
      });
    },
    saveResult() {
      this.loading = true
      let payload = {
        status: this.query.type,
        note: this.query.call_note,
        desired_schedule: this.query.expectCalendar,
        id: this.$route.params.id
      }
      if (this.query.timeCallAgain) {
        payload.call_time = this.query.timeCallAgain
      }
      if (this.query.extensionDeadline) {
        payload.deadline = this.query.extensionDeadline
      }
      if (this.query.dateGoSchool) {
        payload.time_available = this.query.dateGoSchool
      }
      if (!this.taskInfo?.classroom_id) {
        payload.classroom_id = this.query.class_room
      }
      if (this.isUseNextCourse) {
        payload.next_student_register_course_id = this.query.nextCourse?.id ?? this.query.nextCourse
      }
      if (this.query.expectBranches) {
        payload.expect_branches = this.query.expectBranches
      }
      if (this.query.extensionDeadline) {
        payload.competency_extension_deadline = this.query.extensionDeadline
      }
      this.$store.dispatch(SAVE_RESULT_TASK, payload).then((res) => {
        this.$notify({
          title: 'Success',
          message: 'Nhập kết quả thành công',
          type: 'success'
        });
        this.$emit('loadData')
        this.switchBox()
      }).catch((e) => {
        this.$notify.error({
          title: 'Error',
          message: `${e?.data?.message}`
        });
      }).finally(() => {
        this.loading = false;
      })
    },
    getStudyCalendarOfCenter() {
      this.$store.dispatch(GET_LIST_CALENDAR_OF_CENTER, this.$route.params.id).then((data) => {
        this.listCalendar = data.data
      })
    },
    getListBranches() {
      this.$store.dispatch(GET_LIST_BRANCH_BY_TICKET, this.$route.params.id).then((data) => {
        this.listBranches = data.data
      })
    },
    getNextCourse() {
      this.$store.dispatch(GET_LIST_NEXT_COURSE, this.$route.params.id).then((data) => {
        this.listNextCourse = data?.data;
        if (this.listNextCourse?.length > 0) {
          this.query.nextCourse = this.listNextCourse.find((e) => e.is_default)
        }
      })
    },
    disabledDate(time) {
         return moment(time).isSameOrBefore(moment(this.query.dateGoSchool).subtract(1,'days'))
             || moment(time).isSameOrBefore(moment().subtract(1, 'days'));
    },
    checkDisableRoom(item) {
      return item.current_student === item.number_student
    },
    disableTime(time) {
      return moment(time).isSameOrBefore(this.query.dateGoSchool)
            || moment(time).isSameOrBefore()
         },
    handleChangeResult() {
      this.resetData()
      if (this.isUseNextCourse && this.listNextCourse?.length > 0) {
        this.query.nextCourse = this.listNextCourse.find((e) => e.is_default) ?? null
      }
    },
    resetData() {
      this.query = {
        ...this.query,
        class_room: '',
        call_note: '',
        dateGoSchool: '',
        extensionDeadline: '',
        timeCallAgain: '',
        expectCalendar: null,
        nextCourse: null
      }
      if (this.taskInfo.classroom_id !== 0) {
        this.query.class_room = this.taskInfo.classroom_id
      }
      // this.query.dateGoSchool = moment(this.taskInfo?.created_at, 'HH:mm:ss DD-MM-YYYY').format('YYYY-MM-DD HH:mm')
      this.query.dateGoSchool = ''
    }
  }

}
</script>

<style>
#dialogConfirmResultPhone .el-dialog__body {
  padding: 13px 20px;
}

#BoxPhoneResult {
  border: solid 1px rgba(94, 0, 182, 1) !important;
  padding: 0;
}

.classroom-noti-popper .el-select-dropdown__empty {
  padding: 4px 10px !important;
}

</style>
